import {getParameterByName} from '../../../../../../shared/scripts/ui_utils/ClientUtils.ts'
import {type UIStoreBodyController} from '../../../../../../shared/scripts/store/UIStoreBodyController.ts'
import {UIStoreController} from '../../../../../../shared/scripts/store/UIStoreController.ts'
import {UIStoreState} from '../../../../../../shared/scripts/store/UIStoreState.ts'
import {CA} from '../../../../../../shared/scripts/analytics/Analytics.ts'
import {UIMStoreBodyController} from './UIMStoreBodyController.ts'
import {UIMStoreSidebarController} from './UIMStoreSidebarController.ts'

export class UIMStoreController extends UIStoreController {
    readonly sidebarController: UIMStoreSidebarController
    readonly storeState: UIStoreState
    readonly bodyController: UIStoreBodyController
    readonly headerCoinsContainer: HTMLDivElement

    constructor() {
        super()
        this.sidebarController = new UIMStoreSidebarController()
        this.storeState = new UIStoreState(this)
        this.bodyController = new UIMStoreBodyController(this.storeState, this.sidebarController)

        const purchaseSuccess = getParameterByName('purchase-success')
        if(purchaseSuccess != '1') return
        CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.PurchaseCompleted)
    }
}
